import { termsTab } from '@/pages/policy/constants';
import SubVisual from '@/components/SubVisual';
import PolicySelectBox from '@/pages/policy/components/PolicySelectBox';
import { Outlet } from 'react-router';
import { useTermsPage } from './terms/hook/useTerms';

const TermsPage = () => {
	const { activeTab, dateList, tosContent, handleTabChange, handleDateChange } = useTermsPage();

	return (
		<main id="terms" className={`sub terms`}>
			<SubVisual
				title={termsTab.title}
				subTab={termsTab.subTab}
				currTabIndex={activeTab}
				cate={''}
				onChangeTab={handleTabChange}
			/>
			<section className="sub-content">
				<div className="sub-inner">
					<PolicySelectBox selectItems={dateList} onChangeSelect={handleDateChange} />
					<Outlet context={tosContent} />
				</div>
			</section>
		</main>
	);
};

export default TermsPage;
